<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
<!--      <div class="col-xl-3">-->
<!--        <BranchStatsPanel />-->
<!--      </div>-->
      <!-- end col -->
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Create GL Level 1</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <CreateGlLevel1Form></CreateGlLevel1Form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>

import Layout from "../../router/layouts/main";
import PageHeader from "../../components/AppComponents/page-header";

export default {
  page: {
    title: "Create Gl Level 1",
    meta: [{ name: "Create Gl Level 1", content: window.__env.app.description }]
  },

  components: {
    Layout,
    PageHeader
  },
  data() {
    return {
      name: "CreateGlLevel1",
      title: "Create Gl Level 1",
      items: [
        {
          text: "GlLevel1",
          href: "/"
        },
        {
          text: "Create Gl Level 1",
          active: true
        }
      ]
    };
  }
};
</script>

<style scoped></style>
